import React from 'react'
import getFlattenedImageEntry from '../selectors/entry/get-flattened-image-entry'

const Image = ({ imageEntry }) => {
  const { url, alt } = getFlattenedImageEntry(imageEntry)
  return url && <img alt={alt} src={url} />
}

export default Image
